var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.5,
    transform: "rotate(-180 22 22)",
    stroke: "#9E9E9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6904 32C24.86 32 25.0336 31.9329 25.1638 31.8028C25.4242 31.5424 25.4242 31.1164 25.1638 30.856L16.2526 21.9408L25.0336 13.1597C25.294 12.8994 25.294 12.4733 25.0336 12.213C24.7733 11.9526 24.3473 11.9526 24.0869 12.213L14.8325 21.4674C14.5721 21.7278 14.5721 22.1538 14.8325 22.4142L24.2171 31.8027C24.3473 31.9329 24.5208 32 24.6904 32L24.6904 32Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSvg);
export default __webpack_public_path__ + "static/media/left-svg.983b89618778fe3cdedce8ca6bb6ef23.svg";
export { ForwardRef as ReactComponent };